import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';

import activityGraph from '../icons/activity_graph.svg';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(1),
  },
  header: {
    fontSize: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(2),
    },
    color: theme.palette.header.main,
  },
  formControl: {
    marginLeft: theme.spacing(1),
    minWidth: 120,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
  },
  image: {
    width: '100%',
    maxHeight: '100%',
  },
}));

const CardActivity = () => {
  const classes = useStyles();
  const [days, setDays] = useState(7);

  const handleChange = (event) => {
    setDays(event.target.value);
  };

  return (
    <Paper className={classes.paper} square>
      <div className={classes.title}>
        <Typography noWrap className={classes.header}>
          Card Activity -
        </Typography>
        <FormControl className={classes.formControl}>
          <Select value={days} onChange={handleChange} className={classes.header}>
            <MenuItem value={7}>Last 7 Days</MenuItem>
            <MenuItem value={28}>Last 4 Weeks</MenuItem>
            <MenuItem value={84}>Last 12 Weeks</MenuItem>
            <MenuItem value={365}>Last Year (by month)</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div className={classes.content}>
        <img className={classes.image} src={activityGraph} alt="Activity graph" />
      </div>
    </Paper>
  );
};

export default CardActivity;
